import React, { useEffect, useState } from 'react';

import { Button, Text, WrapperFlex } from '@unimed-fesp/components';

import * as jwtDecode from 'jwt-decode';
import { BsPlus } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as WebhookIntegrationActions } from '../../../store/ducks/webhookIntegration';
import theme from '../../../styles/theme';
import LoadingSpinner from '../../molecules/LoadingSpinning';
import ModalCancelAction from '../ModalCancelAction';
import ModalEventosWebhook from '../ModalEventosWebhook';
import TableCadastroWebhook from '../TableCadastroWebhook';
import TableCadastroWebHookBody from '../TableCadastroWebhook/TableCadastroWebHookBody';
import TableCadastroWebhookEvents from '../TableCadastroWebhookEvents';

const CadastroWebhook = () => {
  const dispatch = useDispatch();
  const { getWebhookConfiguration } = useSelector(
    (state) => state.webhookIntegration
  );

  const [openModalDeletarConfiguracao, setOpenModalDeletarConfiguracao] =
    useState(false);

  const [openModalEventos, setOpenModalEventos] = useState(false);

  const { accessToken } = useSelector((state) => state.auth);

  const { IsAdm } = jwtDecode(accessToken);

  const dados = getWebhookConfiguration.data;

  const headers = [
    {
      id: 1,
      title: 'Código da Contratante',
      maxWidth: '100',
      minWidth: '50',
    },
    {
      id: 2,
      title: 'Data de criação',
      maxWidth: '150',
      minWidth: '150',
    },
    {
      id: 3,
      title: 'Criado por',
      maxWidth: '150',
      minWidth: '150',
    },
    dados?.updatedAt
      ? {
          id: 4,
          title: 'Data de atualização',
          maxWidth: '120',
          minWidth: '120',
        }
      : null,
    dados?.updatedBy
      ? {
          id: 5,
          title: 'Atualizado por',
          maxWidth: '150',
          minWidth: '150',
        }
      : null,
    IsAdm.toLowerCase() === 'true'
      ? {
          id: 6,
          title: 'Ativo',
          maxWidth: '50',
          minWidth: '50',
        }
      : null,
    {
      id: 7,
      title: '',
      maxWidth: '100',
      minWidth: '100',
    },
  ].filter(Boolean);

  useEffect(() => {
    dispatch(WebhookIntegrationActions.getWebhookConfigurationRequest());
  }, []);

  const deletarWebhook = (idWebhook) => {
    dispatch(
      WebhookIntegrationActions.deleteWebhookIntegrationRequest(idWebhook)
    );
    setOpenModalDeletarConfiguracao(false);
  };

  const toggleWebhook = (params) =>
    dispatch(WebhookIntegrationActions.putWebhookIntegrationRequest(params));

  const adicionarNovaConfiguracao = () =>
    dispatch(WebhookIntegrationActions.postWebhookIntegrationRequest());

  if (getWebhookConfiguration.loading) {
    return <LoadingSpinner />;
  }
  return (
    <WrapperFlex column fullHeight fullWidth>
      <Text
        font="bold 16px/14px Calibri"
        color={theme.greenDefault}
        text="Eventos de Webhook"
        paddingBottom={20}
      />

      {dados ? (
        <WrapperFlex column>
          <TableCadastroWebhook
            headers={headers}
            body={
              <TableCadastroWebHookBody
                deletarWebhook={() => setOpenModalDeletarConfiguracao(true)}
                toggleWebhook={toggleWebhook}
                openModalEventos={() => setOpenModalEventos(true)}
              />
            }
          />
          {IsAdm.toLowerCase() === 'false' && !dados.isActive && (
            <Text
              text="
            As configurações de envio de notificações (Webhook) foram desativadas pelo administrador. 
            Você pode fazer alterações cadastrais, mas não será notificado. 
            Se desejar receber as notificações, por favor, entre em contato com o administrador."
            />
          )}
        </WrapperFlex>
      ) : (
        <WrapperFlex column justifyCenter alignCenter fullWidth>
          <WrapperFlex justifyEnd alignCenter column width={450} gap={16}>
            <Text
              text="Não existem configurações de envio de notificações (Webhook) para essa contratante.
              Se desejar receber as notificações, por favor, cadastre as notificações clicando no botão abaixo."
            />
            <Button
              tipo="primary"
              paddingTop={10}
              paddingRight={10}
              paddingBottom={10}
              paddingLeft={10}
              type="button"
              font="16px unimed_slabregular"
              onClick={() => adicionarNovaConfiguracao()}
            >
              <BsPlus color="#FFFF" size="20" />
              Nova configuração
            </Button>
          </WrapperFlex>
        </WrapperFlex>
      )}
      <ModalCancelAction
        isOpen={openModalDeletarConfiguracao}
        onClickOk={() => deletarWebhook(dados.id)}
        onClick={() => setOpenModalDeletarConfiguracao(false)}
        text="Ao excluir a configuração, todos os cabeçalhos e valores serão permanentemente removidos."
        textHeader="Excluir configuração"
        loading={getWebhookConfiguration.loading}
      />
      <ModalEventosWebhook
        isOpen={openModalEventos}
        onCloseModal={() => setOpenModalEventos(false)}
        titleModal="Eventos Webhook"
        BodyModal={<TableCadastroWebhookEvents webhookId={dados?.id} />}
      />
    </WrapperFlex>
  );
};

export default CadastroWebhook;
